import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import WidgetWrap from '@/features/dashboard/components/widgets/WidgetWrap.vue';
import NoContent from '@/features/dashboard/components/widgets/NoContent.vue';
import { Widgets } from '@/features/dashboard/types';

@Component({
  components: {
    WidgetWrap,
    NoContent,
  },
})
export class WidgetMixin extends Vue {
  @Prop({ required: true }) position!: number;

  @Prop({ required: true }) totalPositions!: number;

  public currentPosition = 0;

  public show = false;

  public widgetKey = Date.now().toString();

  get widgets(): Widgets {
    return this.$store.getters.getWidgets;
  }

  @Watch('position', { immediate: true })
  private setCurrentPosition(newValue: number) {
    this.currentPosition = newValue;
  }

  public apply(size: 'big' | 'small'): void {
    if (this.position === this.currentPosition) return;

    const widgetElements = Object.entries(this.widgets).map((el) => {
      return {
        ...el[1],
        key: el[0],
      };
    });

    const currentWidget = widgetElements.find(
      (widget) => widget.size === size
        && widget.show === true
        && widget.position === this.currentPosition,
    );

    if (!currentWidget) return;

    this.$store.commit('updateWidgetSettings', {
      dashboardWidget: currentWidget.key,
      visible: true,
      position: this.position,
      itemsShown: currentWidget.itemsShown,
      customSettings: currentWidget.customSettings,
    });
  }

  public rerenderWidget(): void {
    this.widgetKey = `${this.widgetKey}-${Date.now()}`;
  }

  public dropdownFocusHandler(): void {
    const { widgetWrap } = this.$refs;
    if (widgetWrap) {
      ((widgetWrap as Vue).$el as HTMLElement).style.zIndex = '50';
    }
  }

  public dropdownBlurHandler(): void {
    const { widgetWrap } = this.$refs;
    if (widgetWrap) {
      setTimeout(() => {
        ((widgetWrap as Vue).$el as HTMLElement).style.zIndex = 'auto';
      }, 100);
    }
  }
}
